<div class="statusBarWrapper">
    @if (isLoading()) {
        <i class="fas fa-spinner fa-spin"></i>
    } @else {
        <div class="progress-bar">
            <div class="progress-bar-fill" [class]="colorClass()" [ngStyle]="{ 'width.%': barValue() }"></div>
        </div>
        <span class="usage-label">{{ displayValue() }}%</span>
    }
</div>
